import { supabase } from '../supabaseClient';
import { User } from '../types/models';

export const userService = {
  // Pobiera wszystkich użytkowników, którzy mają rolę 'kursant'
  getAllStudents: async (): Promise<User[]> => {
    const { data, error } = await supabase
      .from('profiles')
      .select('id, first_name, last_name, role, login')
      .eq('role', 'kursant');

    if (error) {
      console.error("Błąd podczas pobierania listy kursantów:", error);
      throw new Error(error.message);
    }

    return data.map(profile => ({
      id: profile.id,
      firstName: profile.first_name,
      lastName: profile.last_name,
      role: profile.role,
      login: profile.login,
    }));
  }
};